import { useEffect } from 'react';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// locales
import ThemeLocalization from './locales';
// components
import SnackbarProvider from './components/snackbar';
import { ThemeSettings } from './components/settings';
import { MotionLazyContainer } from './components/animate';
// import AuthDebugger from './components/auth/AuthDebugger';
// utils
import { warmupSupabaseConnection } from './utils/supabaseWarmup';

// ----------------------------------------------------------------------

export default function App() {
  // Warm up Supabase connection on app mount
  useEffect(() => {
    warmupSupabaseConnection();
  }, []);
  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <ThemeSettings>
          <ThemeLocalization>
            <SnackbarProvider>
              <Router />
              {/* <AuthDebugger /> */}
            </SnackbarProvider>
          </ThemeLocalization>
        </ThemeSettings>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}
